module.exports = __webpack_public_path__ + "static/img/manual-1.530fde0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-1.png
// module id = PUXN
// module chunks = 4